import { render } from "./ReportPurchaseDetailIndex.vue?vue&type=template&id=661e4187&scoped=true"
import script from "./ReportPurchaseDetailIndex.vue?vue&type=script&lang=js"
export * from "./ReportPurchaseDetailIndex.vue?vue&type=script&lang=js"

import "./ReportPurchaseDetailIndex.vue?vue&type=style&index=0&id=661e4187&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661e4187"]])

export default __exports__